export const APP_NAME = 'BuildPro';
export const APP_SUBTITLE = 'Gestión de Obras y Presupuestos';
export const APP_COLOR = '#f59e0b';
